import React from "react";
import { useState, useEffect } from "react";
import { FaBars } from "react-icons/fa";

function Link({ className, text, href }) {
    return (
        <a className={className} href={href}>
            {text}
        </a>
    );
}

function Navbar() {
    const [scroll, setScroll] = useState(false);
    const [click, setClick] = useState(false);
    const isNavbarClicked = (click) => {
        if (click) {
            return "-ml-12 mt-12 bg-slate-900 lg:mt-0 lg:bg-transparent transition-all px-16 opacity-100 fixed z-0 lg:static text-slate-300 font-semibold flex text-center font-poppins items-center h-96 lg:h-fit lg:flex-row flex-col gap-4 lg:gap-0 w-full whitespace-nowrap justify-evenly lg:justify-around";
        } else {
            return "ml-96 mt-12 opacity-0 lg:opacity-100 lg:m-0 fixed transition-all lg:static text-slate-300 font-semibold flex text-center font-poppins items-center h-96 lg:h-fit lg:flex-row flex-col gap-4 lg:gap-0 md:w-3/6 w-full whitespace-nowrap justify-evenly lg:justify-around";
        }
    };

    useEffect(() => {
        window.addEventListener("scroll", () => {
            setScroll(window.scrollY >= 70);
        });
    }, []);

    return (
        <React.Fragment>
            <nav className="nav">
                <div
                    className={
                        scroll
                            ? "bg-slate-900 transition-all main-container lg:bg-opacity-90 bg-opacity-100 text-center fixed z-50  w-full justify-between flex px-12 p-5"
                            : "bg-transparent transition-all main-container lg:bg-opacity-90 bg-opacity-100 text-center fixed z-50  w-full justify-between flex px-12 p-5"
                    }
                >
                    <div className="flex text-center p-0 m-0">
                        <Link className="text-xl md:text-2xl font-mono font-semibold text-sky-400" text="myConfession" href="/" />
                    </div>
                    <FaBars size={"28px"} onClick={() => setClick(!click)} className="text-slate-200 lg:hidden" />
                    {/* text-slate-300 font-semibold flex text-center font-poppins items-center h-96 lg:h-fit lg:flex-row flex-col gap-4 lg:gap-0 md:w-3/6 w-full whitespace-nowrap justify-around */}
                    <div className={isNavbarClicked(click)}>
                        <Link className="hover:text-sky-400" href="/" text="Home" />
                        <Link className="hover:text-sky-400" href="/about" text="About" />
                        <Link className="hover:text-sky-400" href="/confession" text="All Confession" />
                        <Link
                            className=" whitespace-nowrap z-10  focus:outline-none focus:ring-2  text-white font-semibold h-12 px-6 rounded-lg w-full flex items-center justify-center sm:w-auto bg-sky-500 highlight-white/20 hover:bg-sky-600"
                            href="/create"
                            text="Get Started"
                        />
                    </div>
                </div>
            </nav>
        </React.Fragment>
    );
}

export default Navbar;
